<template>
  <div class="w-full">
    <vs-popup :title="'Editar Informações do Serviço'" :active.sync="modalOs">
      <VuePerfectScrollbar class="scroll-editar-obs" :settings="settings">
        <vs-row
          v-if="rascunho && rascunho.id"
          id="obsServico"
          class="w-full vs-con-loading__container"
          vs-w="12"
          vs-type="flex"
          vs-justify="center"
          vs-align="flex-start"
        >
          <vs-col vs-w="12">
            <vs-row
              class="mb-2"
              vs-w="12"
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="center"
            >
              <vs-col
                vs-w="12"
                class="modal-editar-obs__confirmacao-box"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="center"
              >
                <span class="modal-editar-obs__confirmacao-text">
                  <b>Pessoa que confirmou:</b
                  >{{
                    rascunho.pessoa_confirmacao &&
                    String(rascunho.pessoa_confirmacao).trim()
                      ? rascunho.pessoa_confirmacao
                      : "—"
                  }}
                </span>
              </vs-col>
            </vs-row>

            <vs-row class="mb-2" vs-w="12" vs-type="flex">
              <vs-col vs-w="12" vs-justify="center" vs-align="center">
                <vs-row vs-w="12" vs-type="flex">
                  <label style="color: black; font-size: 0.85rem" class="m-0"
                    >Prioridade</label
                  >
                  <vs-col vs-w="12">
                    <el-select
                      v-model="rascunho.id_nivel_prioridade"
                      clearable
                      filterable
                      placeholder="Selecione..."
                      style="width: 100%"
                      popper-class="modal-editar-obs-el-dropdown"
                      :popper-append-to-body="true"
                    >
                      <el-option
                        v-for="nivel in nivel_prioridade"
                        :key="nivel.id"
                        :label="nivel.nome"
                        :value="nivel.id"
                      ></el-option>
                    </el-select>
                  </vs-col>
                </vs-row>
              </vs-col>
            </vs-row>

            <vs-row
              class="mb-3 mt-4"
              vs-w="12"
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="center"
            >
              <vs-col
                vs-w="3"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                <vs-checkbox
                  color="success"
                  v-model="rascunho.fog"
                  @change="atualizarCarros"
                  >FOG</vs-checkbox
                >
              </vs-col>
              <vs-col
                vs-w="2.5"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                <vs-checkbox
                  color="success"
                  v-model="rascunho.escada"
                  @change="atualizarCarros"
                  >ESCADA</vs-checkbox
                >
              </vs-col>
              <vs-col
                vs-w="2"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                <vs-checkbox
                  color="success"
                  v-model="rascunho.ubv"
                  @change="atualizarCarros"
                  >UBV</vs-checkbox
                >
              </vs-col>
              <vs-col
                vs-w="3.5"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                <vs-input-number
                  color="success"
                  v-validate="'required|numeric'"
                  label="Carros"
                  min="0"
                  :disabled="true"
                  v-model="rascunho.carros"
                  name="carros"
                />
              </vs-col>
            </vs-row>

            <vs-row
              class="mt-1 mb-2"
              vs-w="12"
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
            >
              <vs-col vs-w="12">
                <vs-textarea
                  color="dark"
                  class="w-full"
                  type="text"
                  height="90"
                  label="Observação"
                  v-model="rascunho.obs"
                />
              </vs-col>
            </vs-row>
            <vs-row
              class="mt-1 mb-2"
              vs-w="12"
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
            >
              <vs-col vs-w="12">
                <vs-textarea
                  color="dark"
                  class="w-full"
                  style="text-align: justify !important"
                  height="90"
                  type="text"
                  label="Observação Próximo Serviço"
                  v-model="rascunho.obs_proximo_servico"
                />
              </vs-col>
            </vs-row>
            <vs-row
              class="mt-1 mb-2"
              vs-w="12"
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
            >
              <vs-col vs-w="12">
                <vs-textarea
                  color="dark"
                  class="w-full"
                  style="text-align: justify !important"
                  height="90"
                  type="text"
                  label="Observação Interna"
                  v-model="rascunho.obs_interna"
                />
              </vs-col>
            </vs-row>
            <vs-row
              vs-w="12"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              <vs-col vs-w="12">
                <vs-button
                  class="w-full mt-3"
                  color="success"
                  icon="save"
                  size="sm"
                  type="relief"
                  @click="editarObs()"
                  >Salvar</vs-button
                >
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </VuePerfectScrollbar>
    </vs-popup>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";
export default {
  props: {
    osSelecionado: {},
    contrato: null,
  },
  data() {
    return {
      rascunho: null,
      modalOs: false,
      nivel_prioridade: [
        { id: 1, nome: "Baixa" },
        { id: 2, nome: "Média" },
        { id: 3, nome: "Alta" },
      ],
      settings: {
        maxScrollbarLength: 160,
        wheelSpeed: 0.6,
        height: 1500,
      },
    };
  },
  watch: {
    modalOs(aberto) {
      if (aberto) {
        this.rascunho = this.clonarOs(this.osSelecionado);
      } else {
        this.rascunho = null;
      }
    },
  },
  methods: {
    clonarOs(os) {
      if (!os || typeof os !== "object") {
        return null;
      }
      try {
        return JSON.parse(JSON.stringify(os));
      } catch (e) {
        return Object.assign({}, os);
      }
    },
    async openModal() {
      this.modalOs = true;
    },
    atualizarCarros() {
      if (!this.rascunho) return;

      const isFog = this.rascunho.fog && this.rascunho.fog !== "0" && this.rascunho.fog !== 0;
      const isUbv = this.rascunho.ubv && this.rascunho.ubv !== "0" && this.rascunho.ubv !== 0;
      const isEscada = this.rascunho.escada && this.rascunho.escada !== "0" && this.rascunho.escada !== 0;
      const algumAtivo = isFog || isUbv || isEscada;
      
      let carrosExigido = 0;
      if (this.rascunho.id_tipo !== 4 && this.rascunho.id_tipo !== 5) {
        if (this.rascunho.id_tipo === 1 || this.rascunho.inicial) {
          carrosExigido = parseInt(this.contrato && this.contrato.carros_inicial) || 0;
        } else {
          carrosExigido = parseInt(this.contrato && this.contrato.carros) || 0;
        }
      }

      if (carrosExigido > 0) {
        this.rascunho.carros = this.rascunho.carros > 0 ? this.rascunho.carros : (carrosExigido || 1);
      } else {
        this.rascunho.carros = algumAtivo ? (this.rascunho.carros || 1) : 0;
      }
    },
    async editarObs() {
      if (!this.rascunho || !this.rascunho.id) return;
      await this.$vs.loading({ container: "#obsServico", scale: 0.6 });
      try {
        const isFog = this.rascunho.fog && this.rascunho.fog !== "0" && this.rascunho.fog !== 0;
        const isUbv = this.rascunho.ubv && this.rascunho.ubv !== "0" && this.rascunho.ubv !== 0;
        const isEscada = this.rascunho.escada && this.rascunho.escada !== "0" && this.rascunho.escada !== 0;
        const semEquipamento = !isFog && !isUbv && !isEscada;
        
        let carrosExigido = 0;
        if (this.rascunho.id_tipo !== 4 && this.rascunho.id_tipo !== 5) {
          if (this.rascunho.id_tipo === 1 || this.rascunho.inicial) {
            carrosExigido = parseInt(this.contrato && this.contrato.carros_inicial) || 0;
          } else {
            carrosExigido = parseInt(this.contrato && this.contrato.carros) || 0;
          }
        }

        if (carrosExigido > 0) {
          this.rascunho.carros = this.rascunho.carros > 0 ? this.rascunho.carros : (carrosExigido || 1);
        } else if (semEquipamento) {
          this.rascunho.carros = 0;
        }

        let obj = {
          obs: this.rascunho.obs,
          obs_proximo_servico: this.rascunho.obs_proximo_servico,
          obs_interna: this.rascunho.obs_interna,
          escada: this.rascunho.escada,
          fog: this.rascunho.fog,
          ubv: this.rascunho.ubv,
          carros: this.rascunho.carros,
          id_nivel_prioridade:
            this.rascunho.id_nivel_prioridade === "" ||
            this.rascunho.id_nivel_prioridade === undefined
              ? null
              : this.rascunho.id_nivel_prioridade,
        };
        await this.$http.put(`os/${this.rascunho.id}`, obj);
        await this.$vs.notify(this.$notify.Success);
        this.$emit("update");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        await this.$vs.loading.close("#obsServico > .con-vs-loading");
        this.modalOs = false;
      }
    },
  },
  async mounted() {
    await this.openModal();
  },
  components: {
    ...components,
  },
};
</script>

<style>
.scroll-editar-obs {
  max-height: 80vh !important;
}

/* Dropdown do Element acima do vs-popup */
.modal-editar-obs-el-dropdown {
  z-index: 200010 !important;
}

.modal-editar-obs__confirmacao-box {
  padding: 10px 12px;
  background: #f4f6f8;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  box-sizing: border-box;
}

.modal-editar-obs__confirmacao-text {
  font-size: 12px;
  color: #334155;
  line-height: 1.4;
  word-break: break-word;
}

.modal-editar-obs__confirmacao-text b {
  color: #334155;
  margin-right: 6px;
}
</style>
